import React, { useCallback, useEffect } from 'react';
import BzFormControlWithHook from '../../../../../components/forms/BzFormControlWithHook';
import { CallbackFn, useFormInput, ValidatorType } from '../../../../../hooks/useFormInput';
import CopyEndpointPopover from '../../../../../components/ui/CopyEndpointPopover/CopyEndpointPopover';
import { useIsMount } from '../../../../../hooks/useIsMountHook';
import _ from 'lodash';

interface BasePathInputProps {
  value: string;
  onChange: (value: string) => void;
  displayCopyMessage: boolean;
  groupEndpointUrl: string;
  existingPaths: string[];
  disabled: boolean;
}

const BasePathInput = (props: BasePathInputProps) => {
  const isMount = useIsMount();

  useEffect(() => {
    if (!isMount && basePathInput.value !== props.value) {
      //basePathInput.resetValue(props.value);
    }
  }, [props.value]);

  const updateBasePathHandler = useCallback(
    _.debounce((value: string) => {
      props.onChange(value);
    }, 650),
    [],
  );

  const basePathInput = useFormInput(
    props.value,
    (fn: CallbackFn) => {
      if (fn.isValid) {
        updateBasePathHandler(fn.value as string);
      }
    },
    {
      type: ValidatorType.INVALID_INIT_CHARACTER,
      value: '/',
      invalidMessage: 'Base Path has to start with "/"',
    },
    {
      type: ValidatorType.REQUIRED,
      invalidMessage: 'Base Path is required.',
    },
    {
      type: ValidatorType.INVALID_LEADING_SPACES,
      invalidMessage: 'Base Path is invalid.',
    },
    //Only create this validator if there is some existing paths available
    props.existingPaths && {
      type: ValidatorType.VALUE_FOUND_ON_ARRAY,
      value: props.existingPaths,
      invalidMessage: 'Base Path is already defined in the Group. Please use unique one.',
    },
  );

  return (
    <BzFormControlWithHook
      icon={!_.isNil(props.groupEndpointUrl) && <CopyEndpointPopover endpoint={props.groupEndpointUrl + props.value} />}
      autoComplete="off"
      useFormInputHook={basePathInput}
      placeholder={'Enter a Base Path...'}
      required={true}
      disabled={props.disabled}
    />
  );
};

export default BasePathInput;
